<template>
  <div ref="wrapper" @scroll.passive="e => $emit('scroll', e)">
    <slot />
  </div>
</template>

<script>
import { ResizeObserver } from '@juggle/resize-observer'

export default {
  mounted () {
    this.$nextTick(() => {
      this.ro = new ResizeObserver((entries) => {
        this.$emit('update-height', entries[0].contentRect.height)
      })
      this.ro.observe(this.$refs.wrapper)
    })
  }
}
</script>
